module.exports = __webpack_public_path__ + "static/img/industries3.4bb756f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries3.png
// module id = Nml+
// module chunks = 1